<template>
  <div class="promo-block">
    <div class="promo-block__icon" />
    <span class="promo-block__text">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProductPromoBlock',
};
</script>

<style lang="scss" scoped>
  .promo-block {
    --gradient-color: #{$color--basic-blue};
    --bg-color: #{$color--basic-black};
    --icon-background: linear-gradient(270deg, #{$color--basic-blue} 0%, #{$color--basic-purple} 100%);
    --icon-url: url(/images/icons/clock.svg);

    background: linear-gradient(270deg, var(--gradient-color) 0%, var(--bg-color) 93.4%);
    border-radius: 100px;
    padding: 10px 19px 10px 8px ;
    width: max-content;
    display: flex;
    align-items: center;
  }

  .promo-block__icon {
    margin-right: 10px;
    height: 16px;
    width: 16px;
    background: var(--icon-background);
    -webkit-mask: var(--icon-url) no-repeat center;
    mask: var(--icon-url) no-repeat center;
  }

  .promo-block__text {
    font-weight: 500;
    font-size: $text-11px;
    line-height: $text-13px;
    color: $color--basic-white;
  }
</style>
